@if (data$ | async; as resultsDelivery) {
<div id="details-container">
  <div>
    <dl>
      <dt>Trademark:</dt>
      <dd>{{ resultsDelivery?.trademarkName }}</dd>
      <dt>Primary classes:</dt>
      <dd>
        @if (!!resultsDelivery?.classes?.primary?.length) {
        {{
          resultsDelivery?.classes?.primary!.join(' ')
            | classesFormat : undefined
        }}
        }
      </dd>
      <dt>Secondary classes:</dt>
      <dd>
        @if (!!resultsDelivery?.classes?.secondary?.length) {
        {{
          resultsDelivery?.classes?.secondary!.join(' ')
            | classesFormat : undefined
        }}
        }
      </dd>
      <dt>Goods and Services:</dt>
      <dd>
        {{ resultsDelivery?.goodsAndServices }}
      </dd>
      <dt>Goods fragments:</dt>
      <dd>
        @for (gf of resultsDelivery?.goodsFragments; track gf) {
        <p>
          @if (gf.classNumber !== 0) {
          <label>{{ gf.classNumber }}:</label>
          }
          {{ gf.goods }}
        </p>
        }
      </dd>
      <dt>Goods prefixes:</dt>
      <dd>
        {{ resultsDelivery?.goodsPrefixes }}
      </dd>
      <dt>Components:</dt>
      <dd>{{ resultsDelivery?.components }}</dd>
      <dt>ISKIP:</dt>
      <dd>{{ resultsDelivery?.iSkip ? 'Yes' : 'No' }}</dd>
      <dt>Add ons:</dt>
      <dd>
        @for (ao of resultsDelivery?.addOns; track ao.id ) {
        <p>{{ ao.type }}: {{ ao.description }}</p>
        }
      </dd>
      <dt>Customer name:</dt>
      <dd>{{ resultsDelivery?.customerName }}</dd>
      <dt>Contact name:</dt>
      <dd>{{ resultsDelivery?.contactName }}</dd>
      <dt>Special instructions:</dt>
      <dd>
        @for (si of resultsDelivery?.specialInstructions; track si) {
        <p>{{ si.instructionFor }}: {{ si.instruction }}</p>
        }
      </dd>
    </dl>
  </div>
  @if (supported()) {
  <div id="toe-container">
    <dl>
      @if ( resultsDelivery?.orderIndexingNameModels &&
      resultsDelivery.orderIndexingNameModels!.length > 0 ) {
      <dt>Technical Order Entry:</dt>
      } @for (toe of resultsDelivery?.orderIndexingNameModels; track toe.name )
      {
      <dd>
        <div class="toe-and-classes">
          <span class="toe">{{ toe.name }}</span
          ><span>Other classes: {{ toe.otherClassesFlag }}</span>
        </div>
        @for (annotation of toe.annotations; track annotation) {
        <div class="annotations">
          {{ annotation }}
        </div>
        }
      </dd>
      } @if ( isPOCARegisterIncluded(resultsDelivery) &&
      !!resultsDelivery?.pocaThreshold ) {
      <dt>POCA Threshold:</dt>
      <dd>{{ resultsDelivery?.pocaThreshold }}</dd>
      } @if (!!resultsDelivery?.startDate) {
      <dt>Start Date:</dt>
      <dd>{{ resultsDelivery?.startDate }}</dd>
      } @if (!!resultsDelivery?.endDate) {
      <dt>End Date:</dt>
      <dd>{{ resultsDelivery?.endDate }}</dd>
      }
    </dl>
  </div>
  }
</div>
}
